import React, { useState, useEffect, useContext } from "react";
import URLstateContext from "../../../provider/CommonContext";
import {
    GetPostMethodData,
    DecryptAESdata,
} from "../../../provider/ServiceProvider";
import animation from '../../../images/jm-animation.gif';

function ProductBanner(props) {
    const [data, setData] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getSchemeCode = props.SchemeCode;

    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetFundSummary", {
            IVSchemeCode: getSchemeCode
        }).then((data) => {
            setloadingshow(false);
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                setloadingshow(false);
            }
        });
    }, [BaseURL]);

    return (
        <>

            <section className="product_banner-sc" id="banner">
                {/* {(data.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
                {loadingshow ? (
                    <div className="textcentervertex HomeLoader" role="status" aria-live="polite" aria-busy="true">
                        <img src={animation} alt="" aria-hidden="true" />
                        <div className="model_popup">Please Wait...</div>
                    </div>
                ) : (
                    <div>
                        {data.length === 0 ? (
                            <h5 className="errormsgComNew" role="alert">No Data Available</h5>
                        ) : (
                            <>
                                {data && data.map(({ BannerImg, FundName }) => (
                                    <>
                                       {BannerImg && <img src={BannerImg} alt="Product Banner" className="img-fluid" />}
                                    </>
                                ))}
                            </>
                        )}
                    </div>
                )}
                {/* {loadingshow ? <div className="textcentervertex">
                            <img src={animation} alt="Loading" />
                            <div className="model_popup">Please Wait...</div>
                        </div> : ""
                        } */}
            </section>
        </>
    )
}

export default ProductBanner